import { Flow_0_0_2 } from '@flexus/core';

export const SIL_83: Flow_0_0_2 = {
	id: '83',
	name: 'quote_submitted',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for server decision'
		}
	},
	startNode: '',
	nodes: {}
};
